import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import icons from '../../assets/comet/comet.svg';
import { letters } from '../../utils/constants';
import './styles.styl';

class Reorder extends Component {
  constructor(props) {
    super(props);
    props.setReviewSheet(this.renderReviewChunk);
  }

  UNSAFE_componentWillMount() {
    this.handleProps(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.handleProps(newProps);
  }

  handleProps(props) {
    const { setSubmitStatus } = this.props;
    if (!props.input) {
      const moveItems = {};
      setSubmitStatus(true);
      Object.keys(props.data).forEach((item, index) => {
        moveItems[index] = props.data[index];
      });
      props.onInput(moveItems);
    }
  }

  reorderCardClasses = key => {
    const { correctInput, input, isFinalAttempt } = this.props;

    return classNames('reorder-card', {
      'reorder-card--validated': this.props.validationResult !== null,
      success:
        correctInput && correctInput[key] === input[key] && isFinalAttempt,
      error: correctInput && correctInput[key] !== input[key] && isFinalAttempt
    });
  };

  moveItem = (index, up) => {
    const { validationResult, data, onInput } = this.props;

    if (validationResult !== null) {
      return;
    }
    let numberOfOptions = Object.keys(data).length;

    if (index === 0 && up) {
      // if we are removing this object from the start and wrapping it to the bottom
      let newIndex = numberOfOptions - 1;
      let movingItem = data[index];
      Object.keys(data).map(dataPoint => {
        return (data[dataPoint] = data[parseInt(dataPoint, 10) + 1]);
      });
      data[newIndex] = movingItem;
    } else if (index === numberOfOptions - 1 && !up) {
      // if we are removing this object from the end and wrapping it to the start
      let movingItem = data[numberOfOptions - 1];
      Object.keys(data)
        .reverse()
        .map(dataPoint => {
          return (data[dataPoint] = data[parseInt(dataPoint, 10) - 1]);
        });
      data[0] = movingItem;
    } else {
      // otherwise the move proceeds as normal
      let movingItem = data[index];
      let newIndex = up ? index - 1 : index + 1;
      data[index] = data[newIndex];
      data[newIndex] = movingItem;
    }

    onInput(data);
  };

  keyMove = (event, index) => {
    if (!document.activeElement.hasAttribute('aria-hidden')) {
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        this.moveItem(index, false);
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        this.moveItem(index, true);
      }
    }
  };

  renderReviewChunk = () => {
    const { question, data, correctInput } = this.props;
    const renderBlock = (renderData, answer) => {
      return Object.keys(renderData).map(index => {
        return (
          <p key={index} className={`review-${answer ? 'correct' : 'option'}`}>
            {letters[index]}. {renderData[index]}
          </p>
        );
      });
    };

    return (
      <Fragment>
        <p className="review-question">{question}</p>
        {renderBlock(data, false)}
        <p className="review-correct">Correct Answer:</p>
        {renderBlock(correctInput, true)}
      </Fragment>
    );
  };

  render() {
    const { input, correctInput, question } = this.props;

    return (
      <Fragment>
        {question && <h3>{question}</h3>}
        {Object.keys(input ? input : []).map((key, index) => {
          /* eslint-disable jsx-a11y/no-static-element-interactions */
          /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
          return (
            <div
              key={input[key]}
              className={this.reorderCardClasses(key)}
              tabIndex={0}
              aria-labelledby={index}
              onKeyDown={event => this.keyMove(event, index)}
            >
              <div className="reorder-card__link-container">
                <button
                  aria-hidden={true}
                  tabIndex={-1}
                  onClick={() => this.moveItem(index, true)}
                >
                  <svg focusable="false">
                    <use xlinkHref={`${icons}#arrow-up`} />
                  </svg>
                </button>
                <button
                  aria-hidden={true}
                  tabIndex={-1}
                  onClick={() => this.moveItem(index, false)}
                >
                  <svg focusable="false">
                    <use xlinkHref={`${icons}#arrow-down`} />
                  </svg>
                </button>
              </div>
              <p className="reorder-card__text" id={index}>
                <span>{index + 1}</span>
                {input[key]}
              </p>
              {correctInput && this.props.validationResult !== null && (
                <span className="reorder-card__icon">
                  <svg focusable="false">
                    <use
                      xlinkHref={`${icons}#${
                        input[key] === correctInput[key] ? 'check' : 'x'
                      }`}
                    />
                  </svg>
                </span>
              )}
            </div>
          );
          /* eslint-enable jsx-a11y/no-static-element-interactions */
          /* eslint-enable jsx-a11y/no-noninteractive-tabindex */
        })}
      </Fragment>
    );
  }
}

Reorder.defaultProps = {};

Reorder.propTypes = {
  data: PropTypes.object.isRequired
};

export default Reorder;



// WEBPACK FOOTER //
// ../core/src/components/Reorder/Reorder.js